<div [formGroup]="itemSelectionForm">

    <div class="row pt-3" *ngIf="itemSelectionRequired != 2">
        <div class="col-md-7 col-lg-9 col-xl-10"></div>
        <div class="col-md-5 col-lg-3 col-xl-2">
            <input class="form-control" id="sd_item_search_name" type="text"
                placeholder="{{ 'ItemSelection.searchItem' | translate }}" [formControl]="itemSearch"
                (keyup)="searchItem($event)" [(ngModel)]="selectedItemName" autocomplete="off" (keydown)="itemSearchListKeyPressAction($event)">
            <div *ngIf="itemSearch?.value?.length > 1 && showdropDownList" class="searchList" id="item_seach_list_wrapper">
                <a [attr.id]="'searchitem' + i" class="dropdown-item pr-2 pl-2" [ngClass]="{'active-element-in-list': i === currentSearchItemIndex}" (click)="loadItemDeatilsFromSearch(item);"
                    *ngFor="let item of itemResultFromSearch; let i = index" data-toggle="tooltip" data-placement="left"
                    title={{item.itemName}}> {{ item.itemName}}
                    <span id="sd_item_search_identifier">{{item.itemIdentifier.substring(item.itemName.length, item.itemIdentifier.length)}}</span>
                </a>
            </div>
            <div *ngIf="flagItemNotFound" class="validation-error-inline text-danger">
                {{ 'ItemSelection.noItemsFound' | translate }}</div>
        </div>

    </div>
    <!-- Item Category -->
    <div class="row pt-4 pr-5" *ngIf="itemSelectionRequired != 2">
        <div class="col-md-4 col-lg-2 col-xl-2">
            <label for="itemCategory" id="sd_item_category_label">
                {{ 'ItemSelection.itemCategory' | translate }}
                <span *ngIf="itemSelectionRequired" id="mandatory_field">&#42;</span>
            </label>
        </div>
        <div class="col-md-7 col-lg-3 col-xl-3">
            <select class="form-control custom-select" id="sd_item_category" formControlName="category" #c
                [(ngModel)]="selectedCategory" (change)="fetchItemTypes(c.value)"
                [ngClass]="{'error-class': itemSelectionRequired && itemSelectionForm.controls['category'].touched && selectedCategory === defaultCategoryString} ">
                <option *ngIf="itemSelectionRequired == 1" [value]="-1" selected disabled>
                    {{ 'ItemSelection.defaultCategoryString' | translate }}</option>
                <option *ngIf="itemSelectionRequired == 0" [value]="-1" selected>
                    {{ 'ItemSelection.defaultCategoryString' | translate }}</option>
                <option *ngFor="let option of categoryOptions;trackBy:trackByCatOptions" [value]="option.categoryId">
                    {{ option.categoryName }}</option>
            </select>
            <div class="validation-error-inline text-danger" *ngIf="(itemSelectionRequired) &&
                (itemSelectionForm.controls['category'].touched && selectedCategory === defaultCategoryString )">
                {{ 'ItemSelection.selectCategoryValidationMessage' | translate }}
            </div>
        </div>

        <div class="col-lg-1 col-xl-1"></div>
        <!-- Item Type -->
        <div class="col-md-4 col-lg-2 col-xl-2" *ngIf="selectedCategory !== defaultCategoryString">
            <label for="itemType" id="sd_item_type_label">
                {{ 'ItemSelection.itemType' | translate }}
                <span *ngIf="itemSelectionRequired" id="mandatory_field">&#42;</span>
            </label>
        </div>
        <div class="col-md-7 col-lg-3 col-xl-3" *ngIf="selectedCategory !== defaultCategoryString">
            <select class="form-control custom-select" id="sd_item_type" formControlName="itemType" #t
                [(ngModel)]="selectedType" (change)="fetchItems(t.value)"
                [ngClass]="{'error-class': itemSelectionRequired && itemSelectionForm.controls['itemType'].touched && selectedType === defaultItemTypeString  } ">
                <option *ngIf="itemSelectionRequired == 1" [value]="-1" selected disabled>
                    {{ 'ItemSelection.defaultItemTypeString' | translate }}</option>
                <option *ngIf="itemSelectionRequired == 0" [value]="-1" selected>
                    {{ 'ItemSelection.defaultItemTypeString' | translate }}</option>
                <option *ngFor="let option of itemTypeOptions;trackBy:trackByTypeOptions" [value]="option.itemTypeId"
                    data-toggle="tooltip" data-placement="left" title={{option.itemTypeName}}>
                    <p *ngIf="option.itemTypeName.length < 40; else elseBlock">
                        {{ option.itemTypeName }}
                    </p>
                    <ng-template #elseBlock>
                        <p>
                            {{ option.itemTypeName.slice(0,39)+'...' }}
                        </p>
                    </ng-template>
                </option>
            </select>
            <div class="validation-error-inline text-danger" *ngIf="(itemSelectionRequired) && 
                        (itemSelectionForm.controls['itemType'].touched && selectedType === defaultItemTypeString)">
                {{ 'ItemSelection.selectItemTypeValidationMessage' | translate }}
            </div>
        </div>
    </div>
    <div *ngIf="selectedType !== defaultItemTypeString && itemSelectionRequired != 2" class="row pr-5 mt-3">
        <!-- Item ID -->
        <div *ngIf="isItemLoading">
            <zsd-spinner class="itemselectionspinner"></zsd-spinner>
        </div>
        <div class="col-md-4 col-lg-2 col-xl-2">
            <label for="item" id="sd_item_id_label">
                {{ 'ItemSelection.itemID' | translate }}
                <span *ngIf="itemSelectionRequired" id="mandatory_field">&#42;</span>
            </label>
        </div>
        <div class="col-md-7 col-lg-3 col-xl-3">
            <select class="form-control custom-select" id="sd_item_id" #i formControlName="item"
                [(ngModel)]="selectedItem" (change)="setItem()"
                [ngClass]="{'error-class':itemSelectionRequired && selectedItem === defaultItemNameString && itemSelectionForm.controls['item'].touched } ">
                <option *ngIf="itemSelectionRequired == 1" [value]="-1" selected disabled>
                    {{ 'ItemSelection.defaultItemNameString' | translate }}</option>
                <option *ngIf="itemSelectionRequired == 0" [value]="-1" selected>
                    {{ 'ItemSelection.defaultItemNameString' | translate }}</option>
                <option *ngFor="let option of itemNameOptions;trackBy:trackByNameOptions" [value]="option.itemId">
                    {{ option.itemName }}</option>
            </select>
            <div class="validation-error-inline text-danger" *ngIf="(itemSelectionRequired) && 
                (itemSelectionForm.controls['item'].touched && selectedItem === defaultItemNameString)">
                {{ 'ItemSelection.selectItemValidationMessage' | translate }}
            </div>
        </div>
        <div class="col-lg-1 col-xl-1"></div>
        <!--Classification-->
        <div class="col-md-4 col-lg-2 col-xl-2" *ngIf="selectedItem !== defaultItemNameString">
            <label for="classification" id="sd_classification_label">
                {{ 'ItemSelection.classification' | translate }}
            </label>
        </div>
        <div class="col-md-7 col-lg-3 col-xl-3" *ngIf="selectedItem !== defaultItemNameString">
            <select class="form-control custom-select" id="sd_classification" formControlName="classification" #t
                [(ngModel)]="selectedClassification">
                <option *ngFor="let classification of classificationOptions;trackBy:trackByTypeOptions"
                    [value]="classification.classificationId">
                    {{ classification.classificationName }}</option>
            </select>
        </div>

    </div>

    <div *ngIf="selectedItem !== defaultItemNameString && itemSelectionRequired != 2" class="row  pr-5 mt-3">
        <!-- Urgencies -->
        <div class="col-md-4 col-lg-2 col-xl-2">
            <label *ngIf="arePrioritiesDerived" for="item" id="sd_urgency_label">
                {{ 'ItemSelection.urgency' | translate }}
            </label>
            <label *ngIf="!arePrioritiesDerived" for="item" id="sd_urgency_label">
                {{ 'ItemSelection.priority' | translate }}
            </label>
        </div>
        <div class="col-md-7 col-lg-3 col-xl-3">
            <select class="form-control custom-select" id="sd_urgency" formControlName="urgency" #t
                [(ngModel)]="selectedUrgency" (change)="getPriorityString(t.value)">
                <option *ngFor="let urgency of requestUrgencyOptions;trackBy:trackByTypeOptions"
                    [value]="urgency.requestPriorityId">
                    {{ urgency.displayName }}</option>
            </select>
        </div>
        <div class="col-lg-1 col-xl-1"></div>
        <!-- Priority -->
        <div *ngIf="arePrioritiesDerived" class="col-md-4 col-lg-2 col-xl-2">
            <label for="classification" id="sd_priority_label">
                {{ 'ItemSelection.priority' | translate }}
            </label>
        </div>
        <div *ngIf="arePrioritiesDerived" class="col-md-7 col-lg-3 col-xl-3">
            <span id="sd_priority">
                {{ priorityString }}
            </span>
        </div>
    </div>

</div>
<br />